module.exports = __webpack_public_path__ + "static/media/suporte.ca798158.png";